import React from "react";
import { useTranslation } from "react-i18next";
import { Props } from "./types";
import { SearchIcon } from "./searchIcon";
import styles from "./styles.scss";

function SearchInput({ filter, search, autoFocus }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.searchInput}>
      <SearchIcon className={styles.icon} />
      <input
        type="text"
        autoFocus={autoFocus}
        className={styles.input}
        placeholder={t("common.searchInput.placeholder")}
        onChange={({ target }) => search(target.value)}
      />
    </div>
  );
}

export { SearchInput };
